import { types } from "../action-types";

const initialState = {
    Loading: false,
    loading: false,
    success: false,
    error: false,
    response: []
};

const updateInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_INTERVIEW_REQUESTED:
            return {
                ...state,
                Loading: true,
                loading: action.payload.loading,
                response: []
            };

        case types.UPDATE_INTERVIEW_SUCCESS:
            return {
                ...state,
                Loading: false,
                loading: false,
                success: true,
                error: false,
                response: action.payload
            };
        case types.UPDATE_INTERVIEW_FAILURE:
            return {
                ...state,
                Loading: false,
                loading: false,
                success: false,
                error: true,
                response: []
            };
        default:
            return state;
    }
};
export default updateInterviewReducer;
